import { REWARD_OFFERING } from "../../constants";
import CompetitionPage from "../../common/components/CompetitionPage";

function TripComCompetitionMain() {
  const offerId = REWARD_OFFERING.tripComCompetition;

  return (
    <CompetitionPage
      offerId={offerId}
    />
  );
}

export default TripComCompetitionMain;
